var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSerialNameIcon = function SvgSerialNameIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    fillRule: "evenodd",
    d: "M8.471 32.25a2.07 2.07 0 0 1-2.073-2.076V9.623c0-3.732 2.609-5.873 7.158-5.873h8.876c4.614 0 7.155 2.177 7.155 6.129l.008 20.289a2.08 2.08 0 0 1-1.52 1.998 2.06 2.06 0 0 1-1.578-.192l-8.463-4.78-8.546 4.79a2.1 2.1 0 0 1-1.017.266m7.177-12.459c.219.22.507.33.795.33s.576-.11.795-.33l6.205-6.2A1.125 1.125 0 1 0 21.852 12l-5.41 5.404-2.306-2.305a1.126 1.126 0 0 0-1.592 1.592z",
    clipRule: "evenodd"
  })));
};
export default SvgSerialNameIcon;